import React from 'react'

import './style.scss'

const Index = () => {
	return(
		<nav>
			<div className="nav deliveries-nav-tabs" id="nav-tab" role="tablist">
				<a className="nav-item nav-link active d-block" id="nav-industry-tab" data-toggle="tab" href="#nav-industry" role="tab" aria-controls="nav-industry" aria-selected="true">Aktive</a>
                <a className="nav-item nav-link d-block" id="nav-location-tab" data-toggle="tab" href="#nav-location" role="tab" aria-controls="nav-location" aria-selected="false">Pausede</a>
                <a className="nav-item nav-link d-block" id="nav-organization-tab" data-toggle="tab" href="#nav-organization" role="tab" aria-controls="nav-organization" aria-selected="false">Ferdige</a>
			</div>
		</nav>
	)
}

export default Index